import React, { FC } from 'react';
import Icon from '@ant-design/icons';
import { IconProps } from 'ui/components/Icon';

const DirectboxDefaultSVG = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16 22.75H8C2.25 22.75 2.25 19.7 2.25 17V16C2.25 13.77 2.25 11.25 7 11.25C8.19 11.25 8.63 11.54 9.25 12C9.28 12.03 9.32 12.05 9.35 12.09L10.37 13.17C11.23 14.08 12.79 14.08 13.65 13.17L14.67 12.09C14.7 12.06 14.73 12.03 14.77 12C15.39 11.53 15.83 11.25 17.02 11.25C21.77 11.25 21.77 13.77 21.77 16V17C21.75 20.82 19.82 22.75 16 22.75ZM7 12.75C3.75 12.75 3.75 13.77 3.75 16V17C3.75 19.74 3.75 21.25 8 21.25H16C18.98 21.25 20.25 19.98 20.25 17V16C20.25 13.77 20.25 12.75 17 12.75C16.28 12.75 16.13 12.84 15.7 13.16L14.73 14.19C14.01 14.95 13.04 15.37 12 15.37C10.96 15.37 9.99 14.95 9.27 14.19L8.3 13.16C7.87 12.84 7.72 12.75 7 12.75Z'
      fill='currentColor'
    />
    <path
      d='M19 12.75C18.59 12.75 18.25 12.41 18.25 12V6C18.25 3.77 18.25 2.75 15 2.75H9C5.75 2.75 5.75 3.77 5.75 6V12C5.75 12.41 5.41 12.75 5 12.75C4.59 12.75 4.25 12.41 4.25 12V6C4.25 3.77 4.25 1.25 9 1.25H15C19.75 1.25 19.75 3.77 19.75 6V12C19.75 12.41 19.41 12.75 19 12.75Z'
      fill='currentColor'
    />
  </svg>
);

export const DirectboxDefaultOutline: FC<IconProps> = props => (
  <Icon component={DirectboxDefaultSVG} {...props} />
);
